export default {
	"81eea5776173a422388a81ab72c494eb": "確認訂單收銀台-支付結果確認彈窗",
	"1444fb889c027d8288644d53f7003ffc": "等待支付…",
	"9cea2f350bb96b1a934cc871b4679f4b": "支付成功，去領取",
	"38e2bea31f0c67f23dcb0ef1a76e2037": "支付失敗，重新支付"
}
